export const affiliateTableStyles = {
  maxHeight: 'calc(50vh - 80px)',
  maxWidth: '100%',
};

export const backTitleStyles = theme => ({
  ...theme.typography.button,
  marginBottom: theme.spacing(2),
  padding: 0,
});

export const boxStylesStyles = theme => ({
  '& > span': {
    marginTop: '1px',
    padding: 0,
  },
  '& > span > div': {
    marginBottom: 0,
  },
  '&:first-child': {
    marginRight: theme.spacing(0.5),
  },
  alignItems: 'center',
  borderRadius: 4,
  display: 'flex',
  height: 20,
  justifyContent: 'center',
  padding: 2,
  width: 30,
});

export const cellStyles = theme => ({
  '& > p': {
    '&:last-child': {
      marginRight: 0,
    },
    marginRight: theme.spacing(1),
  },
  '& > span': {
    display: 'block',
    fontSize: 16,
  },
  '&:first-child': {
    '&:before': {
      content: 'none',
    },
    borderLeft: 'none',
    left: 0,
    position: 'sticky',
    width: '400px',
    zIndex: 1,
  },
  '&:nth-child(even)': {
    borderLeft: 'none',
    borderRight: 'none',
  },
  alignItems: 'center',
  borderLeft: '1px solid rgba(0, 0, 0, 0.13)',
  borderRight: '1px solid rgba(0, 0, 0, 0.13)',
  display: 'flex',
  height: 48,
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  width: 194,
  [theme.breakpoints.down('sm')]: {
    width: 168,
  },
});

export const cellLgStyles = {
  width: 225,
};

export const cellNoMarginStyles = {
  '& > label': {
    margin: 0,
  },
};

export const containerStyles = theme => ({
  backgroundColor: theme.palette.surface.light,
  display: 'flex',
  minHeight: '100%',
  padding: theme.spacing(6, 2, 0, 0),
  position: 'absolute',
  width: '100%',
  [theme.breakpoints.down('lg')]: {
    display: 'block',
    padding: theme.spacing(7, 0, 0),
  },
});

export const ellipsesActiveStyles = theme => ({
  backgroundColor: theme.palette.secondary.medium,
});

export const ellipsesMenuStyles = theme => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  backgroundColor: theme.palette.white,
  borderRadius: '100%',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  height: 24,
  minWidth: 24,
  paddingBottom: 0,
  width: 24,
});

export const messageContainerStyles = {
  alignItems: 'center',
  display: 'flex',
};

export const messagingStyles = theme => ({
  color: theme.palette.warning.dark,
  marginLeft: theme.spacing(2),
});

export const mobileAlertStyles = theme => ({
  '& > span': {
    color: theme.palette.warning.dark,
    padding: 0,
  },
  borderRadius: '4px',
  height: 19,
  marginLeft: theme.spacing(2),
  textAlign: 'center',
  width: 21,
});

export const multiCheckCellStyles = {
  '& > label': {
    margin: 0,
  },
  justifyContent: 'space-around',
};

export const noBorderStyles = {
  borderLeft: 'none',
  borderRight: 'none',
};

export const rowStyles = {
  alignItems: 'center',
  display: 'inline-flex',
  height: 48,
  justifyItems: 'center',
};

export const scrollTableStyles = {
  width: '100%',
};

export const securityTablesStyles = ({ sidebarOpen, theme }) => ({
  padding: sidebarOpen ? theme.spacing(4, 0, 3, 42) : theme.spacing(4, 0, 3, 8.5),
  transition: theme.transitions.create(['padding-left']),
  width: '100%',
  [theme.breakpoints.down('lg')]: {
    overflowX: 'auto',
    padding: theme.spacing(2, 2, 4, 2),
  },
});

export const spacedBetweenStyles = theme => ({
  '&:nth-child(n+2)': {
    padding: '0 22px 0 35px',
    [theme.breakpoints.down('md')]: {
      padding: '0 17px 0 27px',
    },
  },
  justifyContent: 'space-between',
  padding: theme.spacing(0, 2),
});

export const tableContainerStyles = theme => ({
  backgroundColor: theme.palette.surface.white,
  boxShadow: theme.shadows[1],
  marginTop: theme.spacing(2),
  overflow: 'auto',
  paddingBottom: theme.spacing(2),
  position: 'relative',
});

export const tableHeaderStyles = theme => ({
  '& > div': {
    backgroundColor: theme.palette.surface.white,
    borderBottom: '1px solid rgba(0, 0, 0, 0.13)',
  },
  backgroundColor: theme.palette.surface.white,
  position: 'sticky',
  zIndex: 2,
});

export const tableRowStyles = theme => ({
  '& > div': {
    borderBottom: '1px solid rgba(0, 0, 0, 0.13)',
  },
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:nth-child(odd)': {
    '& > div': {
      backgroundColor: theme.palette.graphic.lighter,
    },
    backgroundColor: theme.palette.graphic.lighter,
  },
});

export const tableRowActiveStyles = theme => ({
  backgroundColor: theme.palette.primary.light,
});

export const tableWrapperStyles = theme => ({
  height: `calc(50vh - 85px)`,
  marginTop: theme.spacing(5),
});

export const toolTipStyles = {
  cursor: 'pointer',
};

export const toolTipWrapperStyles = theme => ({
  '&:last-child': {
    marginRight: 0,
  },
  marginRight: theme.spacing(1),
});

export const userTableStyles = theme => ({
  maxHeight: 355,
  overflowX: 'hidden',
  width: '100%',
  [theme.breakpoints.down('lg')]: {
    overflowX: 'scroll',
  },
});
